import auth from './auth'
import program from './program'
import { combineReducers } from 'redux'

const rootReducer = combineReducers({ auth, program })
export default rootReducer
